<table class="min-w-full">
  <thead class="border-b">
    <tr>
      <ng-container *ngTemplateOutlet="
        headers;
        context: {$implicit: data}
      "></ng-container>
    </tr>
  </thead>
  <tbody>
    @for (row of data | async; track row) {
      <tr class="border-b">
      <ng-container *ngTemplateOutlet="
        rows;
        context: { $implicit: row}
      "></ng-container>
      </tr>
    }
  </tbody>
</table>
